import React from "react";
import MobileNav from "../../components/mobile/nav/MobileNav";
import Footer from "../../components/mobile/footer/Footer";
import MobileFinalRegisterComponent from "../../components/mobile/register/FinalRegister";

export default function FinalRegister() {
  return (
    <>
      <MobileNav />
      <MobileFinalRegisterComponent />
      <Footer />
    </>
  );
}
